<template>
  <main
    class="company page-main"
  >
    <section class="company-visual" data-style="show">
      <picture>
        <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/visual@3x.jpg 3x">
        <source media="(max-width: 750px)" srcset="~@/static/image/company/m/visual@3x.jpg 3x">
        <img src="~@/static/image/company/pc/visual.jpg" :alt="$t('company.head')">
      </picture>
    </section>

    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('company.head') }}</h3>
      <html-view :value="$t('company.copy')" class="page-heading-desc" />
    </section>

    <div>
      <tab
        :tab-list="tabList"
        class="tab-sticky"
        :index="0"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>

        <template v-slot:sub>
          <div class="tab-sub">
            <a :href="`#${$t('vision.name').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('vision.name') }}</a>
            <a :href="`#${$t('principles.name').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('principles.name') }}</a>
            <!--<template>
              <a :href="`#${$t('value.name').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('value.name') }}</a>
              <a :href="`#${$t('people.name').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('people.name') }}</a>
              <a :href="`#${$t('better.name').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('better.name') }}</a>
            </template>-->
          </div>
        </template>
      </tab>
      <culture id="culture" class="sticky" />
    </div>

    <div>
      <tab
        :tab-list="tabList"
        class="tab-sticky"
        :index="1"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>
      </tab>
      <history id="history" class="sticky" />
    </div>

    <!--        <div>
          <tab
            :tab-list="tabList"
            class="tab-sticky"
            :index="2"
            @click:tab="onGoSticky"
          >
            <template v-slot:bar>
              <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
            </template>

            <template v-slot:sub>
              <div class="tab-sub">
                <a :href="`#${$t('resolutions.name')}`" @click="onGoAnchor">{{ $t('resolutions.name') }}</a>
                <a :href="`#${$t('declaration.name')}`" @click="onGoAnchor">{{ $t('declaration.name') }}</a>
                <a :href="`#${$t('conduct.name')}`" @click="onGoAnchor">{{ $t('conduct.name') }}</a>
              </div>
            </template>
          </tab>
          <ethical id="ethical" class="sticky" :company-more="companyMore" />
        </div>-->

    <!--    <div v-if="!companyMore">
      <tab
        :tab-list="tabList"
        class="tab-sticky"
        :index="3"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>

        <template v-slot:sub>
          <div class="tab-sub">
            <a :href="`#${$t('compliance.declaration.name')}`" @click="onGoAnchor">{{ $t('compliance.declaration.name') }}</a>
            <a :href="`#${$t('compliance.program.name')}`" @click="onGoAnchor">{{ $t('compliance.program.name') }}</a>
            <a :href="`#${$t('compliance.unfair.name')}`" @click="onGoAnchor">{{ $t('compliance.unfair.name') }}</a>
          </div>
        </template>
      </tab>
      <compliance id="compliance" class="sticky" />
    </div>-->

    <!--    <div>-->
    <!--      <tab-->
    <!--        :tab-list="tabList"-->
    <!--        class="tab-sticky"-->
    <!--        :index="2"-->
    <!--        @click:tab="onGoSticky"-->
    <!--      >-->
    <!--        <template v-slot:bar>-->
    <!--          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />-->
    <!--        </template>-->

    <!--        <template v-slot:sub>-->
    <!--          <div class="tab-sub">-->
    <!--            <a :href="`#${$t('menuCompany.ethicalManagement').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('menuCompany.ethicalManagement') }}</a>-->
    <!--            <a :href="`#${$t('menuCompany.compliance').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('menuCompany.compliance') }}</a>-->
    <!--            <a :href="`#${$t('sustainable.name').replace(/\s/g, '')}`" @click="onGoAnchor">{{ $t('sustainable.name') }}</a>-->
    <!--          </div>-->
    <!--        </template>-->
    <!--      </tab>-->

    <!--      <div id="sustainable" class="sticky">-->
    <!--        <ethical ref="ethicalManagement" />-->
    <!--        <compliance ref="compliance" />-->
    <!--        <sustainable ref="sustainable" />-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div v-if="companyMore" class="more">-->
    <!--      <button type="button" class="btn btn-fill" @click="companyMore = false">{{ $t('free-more') }}</button>-->
    <!--      <icon-chevron-down />-->
    <!--    </div>-->
  </main>
</template>
<script>
import observer from '@/mixins/observer'
import tabScrollbar from '@/mixins/tabScrollbar'
import contentsPage from '@/mixins/contentsPage'
import gtag from '@/mixins/gtag'

import tab from '@/components/base/Tab'
import culture from '@/views/company/Culture'
import history from '@/views/company/History'
import isKorean from '@/mixins/isKorean'
// import ethical from '@/views/company/Ethical'
// import compliance from '@/views/company/Compliance'
// import sustainable from '@/views/company/Sustainable'

export default {
  components: {
    // iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    tab,
    culture,
    history,
    // ethical,
    // compliance,
    // sustainable
  },
  mixins: [observer, tabScrollbar, contentsPage, gtag, isKorean],
  data () {
    return {
      companyMore: true,
      tabList: [
        {
          params: { child: 'culture' },
          name: 'menuCompany.woowaCulture'
        },
        {
          params: { child: 'history' },
          name: 'menuCompany.history'
        },
        // {
        //   params: { child: 'ethical' },
        //   name: 'menuCompany.ethicalManagement'
        // },
        // {
        //   params: { child: 'compliance' },
        //   name: 'menuCompany.compliance'
        // },
        // {
        //   params: { child: 'sustainable' },
        //   name: 'menuCompany.sustainable'
        // }
      ],
      sections: [
        'ethicalManagement',
        'compliance',
        'sustainable'
      ],
      sectionTitles: [
        'menuCompany.ethicalManagement',
        'menuCompany.compliance',
        'sustainable.name'
      ]
    }
  },
  watch: {
    '$route.params.child' (child) {
      // this.removeMore()
      if (child === 'sustainable') {
        this.companyMore = false
      }
    }
  },
  mounted () {
    // this.removeMore()

    setTimeout(this.init, 800)
  },
  methods: {
    init () {
      this.sections.forEach((section, index) => {
        // console.log(this.$refs[section]?.$el)
        if (this.$refs[section]) {
          this.initGtag({
            element: this.$refs[section]?.$el,
            isView: true,
            ga: {
              name: '회사소개_지속가능경영',
              category: '회사소개_지속가능경영',
              label: this.$t(this.sectionTitles[index]),
              page: '회사소개'
            }
          })
        }
      })
    },
    // removeMore () {
    //   // if (!this.$route.params.child) {
    //   //   this.companyMore = true
    //   // }
    //   this.companyMore = !(this.$route.params.child && this.$route.params.child !== 'culture')
    // }
  }
}
</script>
